import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 16, height = 16, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M10 12L6 8L10 4' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
  <path d='M10 12L6 8L10 4' stroke='#2B3346' stroke-opacity='0.5' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
</svg>
